import store from '@/store/store'
import {stories} from '@/class/stories'
import router from '@/router'
import {story} from '@/class/story'
import {saveContentOnglet} from '@/class/onglets/onglet'

export default {
  contents:[
    {
      type:'stories',
      label: store.getters.labelByType('stories'),
      object: new stories(),
      open:false
    }
  ],
  current: [new stories()],
  isActive (route) {
    return this.getCurrent().getRoute() === route
  },
  setActive (object) {
    this.current.push(object)
    console.log(this.current)
  },
  getCurrent () {
    return this.current[this.current.length - 1]
  },
  getStory (storyId) {
    return this.contents.find(c => c.type === 'story' && c.object.getId() === storyId).object
  },
  addStory (object) {

    if (this.contents.find(c => c.object.getRoute() === object.getRoute())) {
      return
    }

    let children = store.getters.getGlobalInfoLink.filter(c => c.type !== 'annotation')

    children = children.map(c => {
      const story = new c.class()
      story._story.set(object.getId())
      return {
        type:c.type,
        object: story,
        label: c.label,
        open:false,
        child:[]
      }
    })

    this.contents.push({
      type:object.getObjectType(),
      label: object.name,
      object,
      child:children,
      open:true
    })
    console.log(this.contents)
    this.setActive(object)
  },
  add (object) {

    const nav = this.contents.find(c => c.object.getId() === object.getStoryId())
    if (nav === undefined) {
      const _story = new story()
      _story.setId(object.getStoryId())
      saveContentOnglet.objectSave(_story)
      _story.load().then(() => {
        this.addStory(_story)
        this.add(object)
      })
      return
    }

    nav.open = true

    const children = nav.child.find(c => c.object.getObjectType() === object.getObjectType())
    if (children === undefined) {
      console.log(`Object introuvable ${object.getObjectType()}`)
      return
    }

    const exist = children.child.findIndex(c => c.object.getRoute() === object.getRoute())

    if (exist > -1) {
      children.child[exist] = {
        type:object.getObjectType(),
        label: object.name,
        object
      }
      return
    }

    children.open = true
    children.child.push({
      type:object.getObjectType(),
      label: object.name,
      object
    })

    this.setActive(object)
  },
  show (content) {
    if (content.object.getObjectType() !== 'stories' && content.object.getId() === 0) {

      const story = this.getStory(content.object.getStoryId())

      story.voletsContent.setActive(
        story.voletsContent.get().findIndex(t => t.type === content.object.getObjectType())
      )

      this.setActive(content.object)

      router.push(story.getRoute())
      return
    }

    content.open = true
    this.setActive(content.object)

    if (content.object.getObjectType() === 'story') {
      const story = this.getStory(content.object.getId())
      story.voletsContent.setActive(0)
    }

    router.push(content.object.getRoute())
  },
  findContentByObject (contents, object) {
    for (const content of contents) {
      if (content.object === object) {
        return content
      }
      if (content.child) {
        const founded = this.findContentByObject(content.child, object)
        if (founded !== null) {
          return founded
        }
      }
    }
    return null
  },
  getAllChildren (content) {
    if (!content.child) return []
    let children = []
    content.child.forEach(c => {
      children = [...children, c, ...this.getAllChildren(c)]
    })
    console.log(children)
    return children
  },
  delete (contents, object) {
    for (const content of contents) {
      if (content.object === object) {
        return contents.filter(o => o.object !== object)
      }
      if (content.child) {
        content.child = this.delete(content.child, object)
      }
    }
    return contents
  },

  close (content) {
    if (content.child) {
      const children = this.getAllChildren(content)
      for (const child of children) {
        this.contents = this.delete(this.contents, child.object)
        this.current = this.current.filter(o => o !== child.object)
      }
    }
    this.contents = this.delete(this.contents, content.object)
    this.current = this.current.filter(o => o !== content.object)

    this.show(this.findContentByObject(this.contents, this.getCurrent()))
  },
  closeByObject (object) {
    const content = this.findContentByObject(this.contents, object)
    if (!content) {
      return
    }
    this.close(content)
  }
}
